import { render } from "./AuthCode.vue?vue&type=template&id=f1b0768e&scoped=true"
import script from "./AuthCode.vue?vue&type=script&lang=js"
export * from "./AuthCode.vue?vue&type=script&lang=js"

import "./AuthCode.vue?vue&type=style&index=0&id=f1b0768e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1b0768e"]])

export default __exports__